<h2 class="modal-title">Import des templates de formulaire dans la DB</h2>

@if (isLoadingTemplates) {
  <div class="loading-container">
    <div class="importation-card">
      <div class="spinner" aria-hidden="true"></div>
      <div class="ml20">
        <div class="f16">Chargement des templates disponibles...</div>
      </div>
    </div>
  </div>
} @else if (isImporting) {
  <div class="import-modal">
    @if (isLoading) {
      <div class="importation-card">
        <div class="spinner" aria-hidden="true"></div>
        <div class="ml20">
          <div class="f16">Importation des templates en cours, veuillez patienter...</div>
          <div class="sub">{{ getCounterByStatus([COMPLETED, ERROR]) }}/{{ getTotalCounter() }} terminés</div>
        </div>
      </div>
    } @else {
      <div class="importation-card">
        <div class="ml20">
          <div class="f16">Importation des templates terminée.</div>
          <div class="sub">{{ getCounterByStatus([COMPLETED, ERROR]) }}/{{ getTotalCounter() }} terminés</div>
        </div>
      </div>
    }

    @for (category of categories; track category.key) {
      <div class="bloc">
        <div class="bloc-header">
          <div class="bloc-title">
            <span>{{ category.label }}</span>
          </div>
        </div>
        <div class="progress-grid">
          @for (template of templatesByCategory[category.key]; track template.id) {
            @if (template.selected) {
              <div class="progress-item">
                <div class="progress-item-txt">
                  <span>{{ translateFormTemplateName(template.name) }}</span>
                  <span class="status"
                        [ngClass]="template.progressInfos.status === COMPLETED ? 'ok' : template.progressInfos.status === WAITING ? 'wait' : template.progressInfos.status === IN_PROGRESS ? 'run' : 'error'">
                    {{ getStatusHr(template.progressInfos.status) }}
                  </span>
                </div>
                @if (template.progressInfos.status === COMPLETED) {
                  <div class="meta">
                    @if (template.progressInfos.injectedCode != null) {
                      <span>Créés&nbsp;: {{ template.progressInfos.injectedCode }}</span>
                    }
                    @if (template.progressInfos.updatedCode != null) {
                      <span>Modifiés&nbsp;: {{ template.progressInfos.updatedCode }}</span>
                    }
                  </div>
                }
                <div class="progress-bar"
                     [ngClass]="template.progressInfos.status === COMPLETED ? 'green' : ''"></div>
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
} @else {
  <div class="import-modal">
    @for (category of categories; track category.key) {
      <div class="bloc">
        <div class="bloc-header">
          <div class="bloc-title">
            <label class="category-checkbox">
              <input type="checkbox"
                     (change)="checkAll($any($event.target).checked, category.key)"
                     [checked]="allTemplatesChecked(category.key)"/>
              <span class="checkmark"></span>
              <span>{{ category.label }}</span>
            </label>
          </div>
        </div>
        <div class="checkbox-grid">
          @for (template of templatesByCategory[category.key]; track template.id; let i = $index) {
            <label class="checkbox-item">
              <input type="checkbox"
                     [(ngModel)]="templatesByCategory[category.key][i].selected"
                     [checked]="templatesByCategory[category.key][i].selected"
                     (ngModelChange)="allTemplatesChecked(category.key)"/>
              <span class="checkmark"></span>
              <span>{{ translateFormTemplateName(template.name) }}</span>
            </label>
          }
        </div>
      </div>
    }
  </div>
}

<div class="footer-actions">
  @if (!isImporting && !isLoadingTemplates) {
    <button class="btn cancel" (click)="closeDialog()">Annuler</button>
    <button class="btn confirm" (click)="importSelectedTemplates()">Importer les templates</button>
  }

  @if (isImporting) {
    <button class="btn cancel" (click)="closeDialog()" [disabled]="isLoading">Fermer</button>
  }
</div>
